import React, {Component} from 'react';
import PropTypes from 'prop-types';
import SidebarItem from './SidebarItem';

class SidebarTree extends Component {
	render() {
		const {title, url, iconClass, sideBarItem} = this.props;
		return (
			<li className="treeview">
				<a href={url}>
					<i className={iconClass}/> <span>{title}</span>
					<span className="pull-right-container">
						<i className="fa fa-angle-left pull-right"/>
					</span>
				</a>
				<ul className="treeview-menu">
					{
						sideBarItem.map((item, index) => {
							return (
								<SidebarItem title={item.title} url={item.url} key={index.toString()}/>
							)
						})
					}
				</ul>
			</li>
		)
	}
}

SidebarTree.defaultProps = {
	url: '',
	iconClass: 'fa fa-circle-o'
};

SidebarTree.propTypes = {
	title: PropTypes.string.isRequired,
	url: PropTypes.string,
	iconClass: PropTypes.string,
	sideBarItem: PropTypes.arrayOf(PropTypes.shape({
		title: PropTypes.string.isRequired,
		url: PropTypes.string.isRequired,
		iconClass: PropTypes.string
	})).isRequired
};

export default SidebarTree